import moment from "moment";

export const generateQueryParams = (obj) => {
  const queryParams = new URLSearchParams();

  // Loop through all keys in obj
  for (const key in obj) {
    const value = obj[key];
    // only include keys with non-empty values
    if (value !== "" && value !== null && value !== undefined) {
      queryParams.append(key, value);
    }
  }
  return queryParams.toString();
};

export function calculateReadingTime(content) {
  // Concatenate all text blocks
  const allText = content.map((block) => block.text || "").join(" ");

  // Count words
  const wordCount = allText.split(/\s+/).filter(Boolean).length;

  // Average reading speed (words per minute)
  const wordsPerMinute = 200;

  // Calculate minutes (round up)
  const timeInMinutes = Math.ceil(wordCount / wordsPerMinute);

  return formatDuration(timeInMinutes); // return in seconds
}

function formatDuration(timeInMinutes) {
  const d = moment.duration(timeInMinutes, "minutes");
  const parts = [];
  const h = d.hours();
  const m = d.minutes();
  const s = d.seconds();

  if (h > 0) parts.push(`${h} ${h > 1 ? "hours" : "hour"}`);
  if (m > 0) parts.push(`${m} ${m > 1 ? "min" : "min"}`);
  if (s > 0) parts.push(`${s} ${s > 1 ? "seconds" : "second"}`);
  return parts.join(" ");
}
